import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  fetchCounter,
  getCount,
  getResetTime,
};

type Counter = {
  count: number;
  reset_time?: number;
};

let g_counterMap: { [key: string]: Counter } = {};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  UserStore.addChangeListener(_onUserChange);
  done && done();
}
function _onUserChange(reason: string) {
  if (reason === 'logout') {
    g_counterMap = {};
    _emit('update');
  }
}

function isReady() {
  return true;
}
function fetchCounter(counter_id: string, done = null) {
  if (UserStore.isLoggedIn()) {
    const opts = {
      url: `/client/1/counter/${counter_id}`,
    };
    UserStore.get(opts, (err, body) => {
      if (err) {
        util.errorLog('CounterStore.fetchCounter: err:', err);
      } else if (body) {
        if (body[counter_id]) {
          g_counterMap[counter_id] = body[counter_id];
        } else {
          g_counterMap[counter_id] = { count: 0 };
        }
        _emit('update');
      }
      done && done(err);
    });
  } else {
    done && done('not_logged_in');
  }
}
function getCount(counter_id: string, def: number | undefined = undefined) {
  let ret = def;
  const counter = g_counterMap[counter_id];
  if (counter) {
    ret = counter.count;
  }
  return ret;
}
function getResetTime(counter_id: string) {
  let ret = 0;
  const counter = g_counterMap[counter_id];
  if (counter && counter.next_reset_time) {
    ret = counter.next_reset_time;
  }
  return ret;
}
